import { Body, Container, Box } from '@hover/blueprint';
import React from 'react';
import { HeaderDescription as HeadingWithBody } from '../common';

interface Props {
  setCurrentSection: React.Dispatch<React.SetStateAction<string>>;
}

const HeaderDescription: React.FC<Props> = () => (
  <Container
    maxW="3xl"
    pt={97}
    pb={97}
    position={{ base: 'relative', desktop: 'absolute' }}
    top={{ base: 0, desktop: '229px' }}
    left={{ desktop: '50%' }}
    transform="auto"
    translateX={{ desktop: '-50%' }}
    translateY={{ desktop: '-50%' }}
    mb={{ base: 900, desktop: 0 }}
  >
    <Box flexDir="column" alignItems="center">
      <HeadingWithBody
        maxW="100%"
        px={0}
        heading="Creativity is a team sport"
        body="“And while we build a new category of platform and data, we also aim to
        build a different kind of company. It’s working: I’ll stack our team
        against any, and fight with a happy heart knowing we can’t lose if we
        stick to our shared team values.”"
      />
      <Body size={500} textAlign="center">
        A.J., HOVER Founder & CEO
      </Body>
    </Box>
  </Container>
);

export default HeaderDescription;
